import React from 'react';
import { Button, Grid, List, Paper, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { styles } from './styles';

interface IProps {
  title: string;
  data: object[];
  filterKey?: { key: string; value: string };
  listItem: (entry: any, index: number) => React.ReactNode;
  onAddMore(): void;
  extraHeaderComponent?: () => React.ReactNode;
}

export const RestaurantEditListBox: React.FC<IProps> = ({
  title,
  data,
  filterKey,
  listItem,
  onAddMore,
  extraHeaderComponent,
}) => {
  const classes = styles();
  const { t } = useTranslation();

  const renderList = () => {
    const result: object[] = data || [];

    return result.map((entry, index) => {
      if (filterKey && entry[filterKey.key] === filterKey.value) {
        return null;
      }
      return listItem(entry, index);
    });
  };

  return (
    <Paper variant="outlined" className={classes.listBox}>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.listBoxHead}
      >
        <Grid item>
          <Typography>{title}</Typography>
        </Grid>
        <Grid item>
          <Button
            endIcon={<Add />}
            className={classes.listBoxHeadButton}
            onClick={onAddMore}
          >
            {t('restaurant.info.edit.addMore')}
          </Button>
        </Grid>
      </Grid>
      {extraHeaderComponent && extraHeaderComponent()}
      <List>{renderList()}</List>
    </Paper>
  );
};
